import { render, staticRenderFns } from "./BizDeliveryGuide.vue?vue&type=template&id=4d2b9e07&scoped=true"
import script from "./BizDeliveryGuide.vue?vue&type=script&lang=js"
export * from "./BizDeliveryGuide.vue?vue&type=script&lang=js"
import style0 from "./BizDeliveryGuide.vue?vue&type=style&index=0&id=4d2b9e07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b9e07",
  null
  
)

export default component.exports